module.exports = __webpack_public_path__ + "static/media/jiggle_wall_fallback.59c8f47d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Intro/img/jiggle_wall_fallback.mp4
// module id = 252
// module chunks = 0